// Image loader helper to fix hot reload issues with dynamic requires
const images = {
  // Support images
  'ufa-bet-support.png': require('../assets/images/ufa-bet-support.webp'),
  'edmbet-support.png': require('../assets/images/edmbet-support.webp'),
  'betflix-support.png': require('../assets/images/betflix-support.webp'),
  'askmebet-support.png': require('../assets/images/askmebet-support.webp'),
  'imiwin-support.png': require('../assets/images/imiwin-support.webp'),

  // Main images
  'Shiba-BG.jpg': require('../assets/images/Shiba-BG.jpg'),
  'Shiba-BG1.jpg': require('../assets/images/Shiba-BG1.jpg'),
  'logo-shiba888.png': require('../assets/images/logo-shiba888.png'),
  'title-shiba.png': require('../assets/images/title-shiba.png'),
  'logo-headline65x400.png': require('../assets/images/logo-headline65x400.png'),
  'logo-landscape.png': require('../assets/images/logo-landscape.png'),
  'gl-logo.png': require('../assets/images/gl-logo.png'),

  // Casino/Game images
  'casino.png': require('../assets/images/casino.png'),
  'casino2.png': require('../assets/images/casino2.png'),
  'game-console.png': require('../assets/images/game-console.png'),
  'lotto.png': require('../assets/images/lotto.png'),
  'roulet.png': require('../assets/images/roulet.png'),
  'spin.png': require('../assets/images/spin.png'),
  'scratch.png': require('../assets/images/scratch.png'),
  'jackpot.png': require('../assets/images/jackpot.png'),

  // Icons and UI
  'avatar.png': require('../assets/images/avatar.png'),
  'home.png': require('../assets/images/home.png'),
  'icdeposit.png': require('../assets/images/icdeposit.png'),
  'icwithdraw.png': require('../assets/images/icwithdraw.png'),
  'gift.png': require('../assets/images/gift.png'),
  'gift-box.png': require('../assets/images/gift-box.png'),
  'coins.png': require('../assets/images/coins.png'),
  'coin1.png': require('../assets/images/coin1.png'),
  'Coin.png': require('../assets/images/Coin.png'),
  'point.png': require('../assets/images/point.png'),
  'favorite.png': require('../assets/images/favorite.png'),
  'favorite150.png': require('../assets/images/favorite150.png'),

  // Special/Event images
  'santa.png': require('../assets/images/santa.png'),
  'merry.jpg': require('../assets/images/merry.jpg'),
  'angpao.png': require('../assets/images/angpao.png'),
  'surprise.png': require('../assets/images/surprise.png'),
  'treasure.png': require('../assets/images/treasure.png'),
  'checkin.png': require('../assets/images/checkin.png'),

  // Other
  'contact.png': require('../assets/images/contact.png'),
  'analysis.png': require('../assets/images/analysis.png'),
  'research.png': require('../assets/images/research.png'),
  'waiting.png': require('../assets/images/waiting.png'),
  'done.png': require('../assets/images/done.png'),
  'note.png': require('../assets/images/note.png'),
  'logout.png': require('../assets/images/logout.png'),
  'ai.png': require('../assets/images/ai.png'),
  'ai3.png': require('../assets/images/ai3.png'),
  'dolla.png': require('../assets/images/dolla.png'),
  'aladin.jpg': require('../assets/images/aladin.jpg'),

  // Loading and background
  'shiba-loading.png': require('../assets/images/shiba-loading.png'),
  'shiba-loading.gif': require('../assets/images/shiba-loading.gif'),
  'wheelbackgroundfinal.png': require('../assets/images/wheelbackgroundfinal.png'),
  'natural-paper-texture.jpg': require('../assets/images/natural-paper-texture.jpg'),
  'bg_home.jpg': require('../assets/images/bg_home.jpg'),
  'bg_wedo.jpg': require('../assets/images/bg_wedo.jpg'),

  // Shiba specific icons
  'shiba888-ic-coin.png': require('../assets/images/shiba888-ic-coin.png'),
  'shiba888-ic-menu-user.png': require('../assets/images/shiba888-ic-menu-user.png'),
  'shiba888-ic-menu-promotion.png': require('../assets/images/shiba888-ic-menu-promotion.png'),
  'shiba888-ic-menu-logout.png': require('../assets/images/shiba888-ic-menu-logout.png'),
  'shiba888-profile-icon-level-02.png': require('../assets/images/shiba888-profile-icon-level-02.png'),
  'shiba888-ic-mobile-left-1.png': require('../assets/images/shiba888-ic-mobile-left-1.png'),
  'shiba888-ic-mobile-left-2.png': require('../assets/images/shiba888-ic-mobile-left-2.png'),
  'shiba888-ic-mobile-right-1.png': require('../assets/images/shiba888-ic-mobile-right-1.png'),
  'shiba888-ic-mobile-right-2.png': require('../assets/images/shiba888-ic-mobile-right-2.png'),
  'shiba888-curve-top.png': require('../assets/images/shiba888-curve-top.png'),
  'shiba888-curve-bottom.png': require('../assets/images/shiba888-curve-bottom.png'),

  // EZ Casino icons
  'ez-slot-ic-coin.png': require('../assets/images/ez-slot-ic-coin.png'),
  'ez-slot-ic_deposit_mobile.png': require('../assets/images/ez-slot-ic_deposit_mobile.png'),
  'ez-slot-ic_withdraw_mobile.png': require('../assets/images/ez-slot-ic_withdraw_mobile.png'),
  'ez-slot-ic_lobby_mobile.png': require('../assets/images/ez-slot-ic_lobby_mobile.png'),
  'ez-slot-ic_lobby_mobile_play.png': require('../assets/images/ez-slot-ic_lobby_mobile_play.png'),

  // Promotion images
  'Pro-1.jpg': require('../assets/images/Pro-1.jpg'),
  'Pro-2.jpg': require('../assets/images/Pro-2.jpg'),
  'Pro-3.jpg': require('../assets/images/Pro-3.jpg'),
  'Pro-4.jpg': require('../assets/images/Pro-4.jpg'),

  // We do images
  'wedo_pict01.png': require('../assets/images/wedo_pict01.png'),
  'wedo_pict02.png': require('../assets/images/wedo_pict02.png'),
  'wedo_pict03.png': require('../assets/images/wedo_pict03.png'),
  'wedo_pict04.png': require('../assets/images/wedo_pict04.png'),
  'wedo_pict05.png': require('../assets/images/wedo_pict05.png'),
  'wedo_pict06.png': require('../assets/images/wedo_pict06.png'),

  // Other images
  'avatar-01.jpg': require('../assets/images/avatar-01.jpg'),
  'avartar.png': require('../assets/images/avartar.png'),
  'img-01.jpg': require('../assets/images/img-01.jpg'),
  'icon-play.png': require('../assets/images/icon-play.png'),
  'line.png': require('../assets/images/line.png'),
  'line-glow-blue.png': require('../assets/images/line-glow-blue.png'),
  'icon-line.svg': require('../assets/images/icon-line.svg'),
  'icon-fb-bttm.jpg': require('../assets/images/icon-fb-bttm.jpg'),
  'btn_hover.png': require('../assets/images/btn_hover.png'),
  'addfriend.png': require('../assets/images/addfriend.png'),
  'addfriend2.png': require('../assets/images/addfriend2.png'),
  'ic-gift.png': require('../assets/images/ic-gift.png')
}

// Function to get image safely
export function getImage(imageName) {
  if (!imageName) {
    console.warn('Image name is undefined or empty')
    return ''
  }

  if (images[imageName]) {
    return images[imageName]
  }

  console.warn(`Image "${imageName}" not found in image loader`)
  return ''
}

// Export all images for direct access if needed
export { images }

// Default export
export default {
  getImage,
  images
} 
